/* APR / Stoll Sport / WOT auf der Fahrzeug-Sammlungsseite (fit-Sammlung von EasySearch)
 * Liest die EasySearch-Auswahl NUR (window.easysearch.curIndex), ändert nichts an EasySearch.
 * Zuordnung: assets/apr-ymm-links.json  (k: EasySearch-Schlüssel -> carIds, c: fit-Sammlung -> carIds)
 * Fahrzeugdaten: Metaobject apr_fahrzeug.cc_json; Shop-Produkte: assets/apr-sku-map.json (SKU oder carId|SKU)
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-apr-fit]');
  if (!root) return;

  var TOKEN = '33a256e0a1c9b076ef41661fdd6e9326';
  var API = '/api/2024-10/graphql.json';
  var CAT_ORDER = ['Ansaugung', 'Ladeluftkühler', 'Turboladersysteme', 'Abgasanlage', 'Klappensteuerung', 'Motorkomponenten', 'Getriebe-Software (DSG)', 'Getriebezubehör', 'Motorzubehör'];
  var els = {
    who: root.querySelector('[data-fit-who]'),
    teaserWho: root.querySelector('[data-fit-teaser-who]'),
    open: root.querySelector('[data-fit-open]'),
    close: root.querySelector('[data-fit-close]'),
    modal: root.querySelector('[data-fit-modal]'),
    chips: root.querySelector('[data-fit-chips]'),
    body: root.querySelector('[data-fit-body]'),
    bar: root.querySelector('[data-fit-bar]')
  };
  var S = { links: null, map: null, cands: [], sel: null, cc: null, carId: '', stage: null, ticked: {}, onlyLegal: false, live: {}, variantSel: {}, liveDone: false };

  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function chf(n) { return 'CHF ' + Number(n).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function gql(query, vars) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN }, body: JSON.stringify({ query: query, variables: vars || {} }) })
      .then(function (r) { return r.json(); }).then(function (j) { if (j.errors) throw new Error(JSON.stringify(j.errors)); return j.data; });
  }

  /* ---------- Start: EasySearch-Auswahl lesen ---------- */
  function waitForEasySearch(cb) {
    var tries = 0;
    (function poll() {
      var es = window.easysearch;
      if (es && es.eventStates && es.eventStates.easysearch_ready) return cb(es);
      if (++tries > 40) return cb(es || null);
      setTimeout(poll, 250);
    })();
  }
  function collectionHandle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? m[1] : ''; }

  function start() {
    Promise.all([
      fetch(root.getAttribute('data-links-url')).then(function (r) { return r.json(); }),
      fetch(root.getAttribute('data-map-url')).then(function (r) { return r.json(); }),
      fetch(root.getAttribute('data-map-url').replace('apr-sku-map.json', 'apr-stage-map.json')).then(function (r) { return r.json(); }),
      fetch(root.getAttribute('data-map-url').replace('apr-sku-map.json', 'apr-ymm-multi.json')).then(function (r) { return r.json(); }),
      fetch(root.getAttribute('data-map-url').replace('apr-sku-map.json', 'apr-pflicht-override.json')).then(function (r) { return r.json(); }).catch(function () { return {}; }),
      fetch(root.getAttribute('data-map-url').replace('apr-sku-map.json', 'apr-standalone-add.json')).then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (r) {
      S.links = r[0]; S.map = r[1]; S.multi = r[3]; S.pflichtOv = r[4] || {}; S.standaloneAdd = r[5] || {};
      Object.keys(r[2]).forEach(function (k) { S.map[k] = r[2][k]; });
      Object.keys(S.map).forEach(function (k) { S.map[k].forEach(function (c) { if (!c.s) c.s = 'ACTIVE'; if (c.c === undefined) c.c = null; c.sku = k.split('|').pop(); }); });
      waitForEasySearch(function (es) {
        var ids = null, who = '';
        var h = collectionHandle();
        var cur = es && es.curIndex ? String(es.curIndex).replace(/,+$/, '') : '';
        /* EasySearch liefert die Auswahl nur direkt nach dem Klick auf "Suchen" -> selbst merken (nur lesen, nichts an EasySearch ändern) */
        if (!cur) { try { var st = JSON.parse(sessionStorage.getItem('apr-fit-sel') || 'null'); if (st && st.col === h) cur = st.key; } catch (e) {} }
        if (cur) {
          if (S.links.k[cur]) { ids = S.links.k[cur]; who = whoOf(cur); remember(h, cur); } else { return; }
        } else if (S.links.c[h]) {
          var mk = S.multi && S.multi[h];
          /* Sammlung gehört zu mehreren YMM-Fahrzeugen und die Auswahl ist unbekannt (z.B. direkter Link) -> Fahrzeug abfragen */
          if (mk && mk.length > 1) { S.pendingKeys = mk; S.pendingCol = h; root.hidden = false; renderKeyChoice(); return; }
          ids = S.links.c[h]; who = '';
        }
        if (!ids || !ids.length) return;
        loadCandidates(ids, who);
      });
    }).catch(function () {});
  }
  function whoOf(cur) { var p = cur.split(','); return 'Gewählt: ' + p[0] + ' ' + p[1] + ' · ' + (p[2] || '').split(' - ').slice(0, 2).join(' · '); }
  function remember(h, cur) { try { sessionStorage.setItem('apr-fit-sel', JSON.stringify({ col: h, key: cur })); } catch (e) {} }
  function renderKeyChoice() {
    els.who.textContent = ''; els.teaserWho.textContent = '';
    els.chips.hidden = false;
    els.chips.innerHTML = '<div class="apr-fit-chips-label">Welches Fahrzeug fährst du?</div>' + S.pendingKeys.map(function (k, i) {
      var p = k.split(',');
      return '<button type="button" class="apr-fit-chip" data-key="' + i + '">' + esc(p[1] + ' · ' + (p[2] || '').split(' - ').slice(0, 2).join(' · ')) + '</button>';
    }).join('');
    els.body.innerHTML = '<p class="apr-fit-note">Bitte wähle dein Fahrzeug – dann siehst du, was dafür erhältlich ist.</p>';
    els.bar.hidden = true;
  }

  function loadCandidates(carIds, who) {
    gql('{ metaobjects(type:"apr_fahrzeug", first:250){ nodes{ handle car: field(key:"csv_car_id"){value} } } }').then(function (d) {
      var byCar = {};
      d.metaobjects.nodes.forEach(function (n) { if (n.car && n.car.value) byCar[n.car.value] = n.handle; });
      var pairs = carIds.map(function (id) { return { id: id, h: byCar[id] }; }).filter(function (p) { return p.h; });
      return Promise.all(pairs.map(function (p) {
        return gql('query($h:String!){ metaobject(handle:{handle:$h, type:"apr_fahrzeug"}){ handle cc: field(key:"cc_json"){value} } }', { h: p.h }).then(function (x) {
          var mo = x.metaobject; if (!mo || !mo.cc || !mo.cc.value) return null;
          return { handle: p.h, carId: p.id, cc: JSON.parse(mo.cc.value) };
        });
      }));
    }).then(function (list) {
      S.cands = list.filter(Boolean);
      if (!S.cands.length) return;
      S.cands.sort(function (a, b) { return label(a.cc).localeCompare(label(b.cc)); });
      root.hidden = false;
      els.who.textContent = who || '';
      els.teaserWho.textContent = who || '';
      renderChips();
      if (S.cands.length === 1) choose(0); else render();
    }).catch(function () {});
  }
  function label(cc) {
    var f = cc.fahrzeug;
    return f.modell + ' · ' + f.typ + ' · ' + f.ps + ' PS' + (f.hinweis ? ' · ' + f.hinweis : '') + (f.mkb ? ' · ' + f.mkb : '');
  }
  /* Typenschein-Nr. (Typengenehmigung(en)) des aktuell gewählten Fahrzeugs - zum Abgleich mit dem eigenen Fahrzeugausweis.
     Nutzt tgn_liste (alle TGN laut Homologationsliste) falls vorhanden, sonst Fallback auf das einzelne tgn-Feld. */
  function tgnHtml() {
    if (!S.cc) return '';
    var list = (S.cc.tgn_liste && S.cc.tgn_liste.length) ? S.cc.tgn_liste : (S.cc.tgn ? [S.cc.tgn] : null);
    if (!list || !list.length) return '';
    var label = list.length > 1 ? 'Typenschein-Nr. (' + list.length + '):' : 'Typenschein-Nr.:';
    return '<div class="apr-fit-tgn">' + esc(label) + ' ' + list.map(function (t) { return esc(t); }).join(', ') + '</div>';
  }
  function renderChips() {
    var tgn = tgnHtml();
    if (S.cands.length < 2) { els.chips.innerHTML = tgn; els.chips.hidden = !tgn; return; }
    els.chips.hidden = false;
    els.chips.innerHTML = '<div class="apr-fit-chips-label">Dein Fahrzeug genauer:</div>' + S.cands.map(function (c, i) {
      return '<button type="button" class="apr-fit-chip' + (i === S.sel ? ' is-on' : '') + '" data-chip="' + i + '">' + esc(label(c.cc)) + '</button>';
    }).join('') + tgn;
  }
  function choose(i) {
    S.sel = i; S.cc = S.cands[i].cc; S.carId = S.cands[i].carId; S.stage = null; S.ticked = {}; S.variantSel = {};
    renderChips(); render(); refreshLive();
  }

  /* ---------- Shop-Zuordnung ---------- */
  function words(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9äöüß ]+/g, ' ').split(/\s+/).filter(function (w) { return w.length > 1; }); }
  function pick(sku, skuHaupt) {
    var cands = S.map[S.carId.slice(0, 12) + '|' + sku] || S.map[sku] || (skuHaupt && S.map[skuHaupt]) || null;
    if (!cands || !cands.length) return null;
    if (cands.length === 1) return cands[0];
    var vw = words(S.cc.fahrzeug.modell + ' ' + S.cc.fahrzeug.typ);
    var best = null, bs = -1;
    cands.forEach(function (c) {
      var tw = words(c.t), sc = c.s === 'ACTIVE' ? 1000 : 0;
      vw.forEach(function (w) { if (tw.indexOf(w) >= 0) sc += 10; });
      if (sc > bs) { bs = sc; best = c; }
    });
    return best;
  }
  function shopFor(a) {
    var c = pick(a.sku, a.sku_haupt);
    if (!c) return null;
    var variants = null;
    if (a.varianten && a.varianten.length > 1) {
      variants = a.varianten.map(function (sk) { var x = S.map[sk] && S.map[sk].filter(function (y) { return y.h === c.h; })[0]; return x ? { sku: sk, c: x } : null; }).filter(Boolean);
      if (variants.length < 2) variants = null;
    }
    var sel = c;
    /* ohne eigene Wahl: bei Abgasteilen die zulassungsfähige Ausführung "mit Schalldämpfer" vorwählen */
    if (variants) { var chosen = S.variantSel[a.sku]; var f = variants.filter(function (v) { return v.sku === chosen; })[0] || variants.filter(function (v) { return /mit\s+Schalld/i.test(v.c.vt || ''); })[0] || variants.filter(function (v) { return v.sku === a.sku; })[0] || variants[0]; sel = f.c; }
    var lv = S.live[sel.v];
    var price = lv ? lv.price : sel.p, compare = lv ? lv.compare : sel.c;
    var orderable = lv ? lv.available : (sel.s === 'ACTIVE' && (!S.liveDone || !sel.h));
    return { c: c, sel: sel, variants: variants, price: price, compare: compare, orderable: orderable, lead: sel.pt || c.pt || (sel.h ? '' : 'ab Lager'), sku: sel.sku || a.sku };
  }
  function refreshLive() {
    var seen = {}, handles = [];
    S.liveDone = false;
    (S.cc.artikel || []).concat(S.cc.stages || []).forEach(function (a) {
      [a.sku].concat(a.varianten || []).forEach(function (sk) { (S.map[sk] || []).forEach(function (c) { if (c.s === 'ACTIVE' && !seen[c.h]) { seen[c.h] = 1; handles.push(c.h); } }); });
    });
    var i = 0, running = 0;
    function next() {
      if (!handles.length) { S.liveDone = true; render(); return; }
      while (running < 6 && i < handles.length) {
        (function (h) {
          running++;
          fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
            if (p && p.variants) p.variants.forEach(function (v) { S.live[v.id] = { price: v.price / 100, compare: v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price / 100 : null, available: v.available, img: p.featured_image || '', title: p.title }; });
          }).catch(function () {}).then(function () { running--; if (i >= handles.length && running === 0) { S.liveDone = true; render(); } else next(); });
        })(handles[i++]);
      }
    }
    next();
  }

  /* ---------- Zeilen (gleiche Produkte zusammenfassen, Set bilden) ---------- */
  function prettyTitle(h) { return String(h || '').split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join(' '); }
  function catOf(a) {
    var k = a.kategorie || '';
    if (/Sound Kit|Control Kit|Klappensteuerung/i.test(a.name || '')) return 'Klappensteuerung';
    if (k === 'Software') return 'Getriebe-Software (DSG)';
    return k || 'Weitere Teile';
  }
  /* Zusaetzliche Artikel, die laut Homologationsliste einzeln (ohne Stage) legal sind, aber im APR-CH-Konfigurator
     fuer dieses Fahrzeug nicht separat aufgefuehrt werden (z.B. weil sie dort nur als Teil einer Stage vorkommen). */
  function standaloneExtras() {
    var list = (S.standaloneAdd && S.standaloneAdd[S.carId.slice(0, 12)]) || [];
    var have = {}; (S.cc.artikel || []).forEach(function (a) { have[a.sku] = 1; });
    return list.filter(function (x) { return !have[x.sku]; }).map(function (x) {
      var c = pick(x.sku); var lv = c && S.live[c.v]; var name = x.name || (lv && lv.title) || (c ? (c.t || prettyTitle(c.h)) : x.sku);
      var z = x.zulassung || 'teilegutachten';
      /* Abgasanlagen mit ECE-Gutachten: einzeln legal, aber verliert die Zulassung sobald ein Motorenteil (Stage/Ansaugung/LLK) dazukommt, ausser es gibt ein Kombinationsgutachten (hier keins bekannt) */
      var immerLegal = z !== 'ece';
      return { sku: x.sku, sku_haupt: x.sku, name: name, kategorie: x.kategorie, zulassung: z, hinweis: 'Laut Homologationsliste einzeln (ohne Stage) legal.', ist_stage: false, _extra: immerLegal };
    });
  }
  function allArtikel() { return (S.cc.artikel || []).concat(standaloneExtras()); }
  function rowsList() {
    var arts = allArtikel().filter(function (a) { return shopFor(a); });
    var byH = {}, order = [];
    arts.forEach(function (a) { var h = shopFor(a).c.h; if (!byH[h]) { byH[h] = []; order.push(h); } byH[h].push(a); });
    var rows = order.map(function (h) { return { key: h, members: byH[h] }; });
    /* APR Turbo Inlet System + Open Air Intake gehören zusammen (nur zusammen montierbar) */
    var iT = -1, iA = -1;
    rows.forEach(function (r, i) { r.members.forEach(function (m) { if (m.sku === 'CI100038') iT = i; if (m.sku === 'CI100038A') iA = i; }); });
    if (iT >= 0 && iA >= 0 && iT !== iA) {
      var rt = rows[iT], ra = rows[iA];
      var merged = { key: 'set-CI100038', members: rt.members.filter(function (m) { return m.sku === 'CI100038'; }), set: ra.members, isSet: true };
      rows = rows.filter(function (r, i) { return i !== iT && i !== iA; });
      rows.push(merged);
    }
    return rows;
  }
  function selMember(row) {
    if (row.isSet) return row.members[0];
    var chosen = S.variantSel['g:' + row.key];
    return row.members.filter(function (m) { return m.sku === chosen; })[0] || row.members[0];
  }
  function rowSkus(row) {
    var m = selMember(row), s = [m.sku];
    if (row.isSet) row.set.slice(0, 1).forEach(function (x) { s.push(x.sku); });
    return s;
  }
  /* Findet die Zeile (+ Mitglied), zu der eine bestimmte Artikel-SKU gehört - für die "Für X zusätzlich nötig"-Auswahlkästchen */
  function findRowBySku(sku) {
    var rows = rowsList();
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i], all = r.members.concat(r.isSet ? r.set : []);
      for (var j = 0; j < all.length; j++) { if (all[j].sku === sku) return { row: r, member: all[j] }; }
    }
    return null;
  }

  /* ---------- Legalitätslogik ---------- */
  var ORDER = ['legal', 'kombi', 'verlust', 'illegal', 'versteckt'];
  /* WOT 1 hat bei VAG-Modellen keine Zulassung: Teile-Kombinationen gibt es nur mit den APR Stages -> keine Stage-Wirkung */
  function wotVag() {
    if (!S.stage) return false;
    var st = (S.cc.stages || []).filter(function (x) { return x.sku === S.stage; })[0];
    return !!st && st.hersteller === 'WOT' && /audi|volkswagen|^vw|seat|cupra|skoda|škoda/i.test(S.cc.fahrzeug.hersteller || '');
  }
  /* Pflichtteile einer Stage: laut Homologationsliste (Excel) wo abweichend (apr-pflicht-override.json), sonst APR */
  function pflichtOf(stageSku) {
    var k = S.carId.slice(0, 12) + '|' + stageSku;
    if (S.pflichtOv && S.pflichtOv[k]) return S.pflichtOv[k];
    var m = (S.cc.stage_matrix || {})[stageSku] || {};
    return m.pflicht || [];
  }
  /* Pflichtteile eines einzelnen Artikels (unabhängig von der Stage, z.B. LLK braucht Crashbar+Schaum-Füllstück fürs Verbauen) */
  function artikelPflicht(a) { return (a && a.pflicht) || []; }
  function isVag() { return /audi|volkswagen|^vw|seat|cupra|skoda|škoda/i.test(S.cc.fahrzeug.hersteller || ''); }
  function noWot(list) {
    if (!isVag()) return list;
    var w = {}; (S.cc.stages || []).forEach(function (x) { if (x.hersteller === 'WOT') w[x.sku] = 1; });
    return list.filter(function (s) { return !w[s]; });
  }
  function classOf(sku) {
    var m = S.cc.stage_matrix || {};
    if (S.stage && m[S.stage] && !wotVag()) { var e = m[S.stage]; for (var i = 0; i < ORDER.length; i++) { if ((e[ORDER[i]] || []).indexOf(sku) >= 0) return ORDER[i]; } }
    var b = m.ohne_stage || {};
    for (var j = 0; j < ORDER.length; j++) { if ((b[ORDER[j]] || []).indexOf(sku) >= 0) return ORDER[j]; }
    return null;
  }
  function nameOf(sku) {
    var all = (S.cc.artikel || []).concat(S.cc.stages || []);
    for (var i = 0; i < all.length; i++) if (all[i].sku === sku || all[i].sku_haupt === sku) return all[i].name;
    return sku;
  }
  function selectedSkus() {
    var o = {};
    rowsList().forEach(function (r) { if (S.ticked[r.key]) rowSkus(r).forEach(function (s) { o[s] = 1; }); });
    if (S.stage) o[S.stage] = 1;
    return o;
  }
  function isFilter(a) { return /Ersatzluftfilter|Luftfilter Reinigungskit/i.test(a.name || ''); }
  function isIntake(a) { return a.kategorie === 'Ansaugung' && !isFilter(a) && a.sku !== 'CI100038M' && a.sku !== 'CI100069'; }
  function powerMod(sel) {
    if (S.stage) return true;
    var found = false;
    (S.cc.artikel || []).forEach(function (a) { if (sel[a.sku] && (isIntake(a) || a.kategorie === 'Ladeluftkühler' || a.kategorie === 'Turboladersysteme')) found = true; });
    return found;
  }
  /* Gewählte Motoren-Hardware ohne Stage (Ansaugung, Ladeluftkühler, Turbolader) - diese lassen eine ECE-Abgaszulassung entfallen */
  function motorHardware(sel) {
    return (S.cc.artikel || []).filter(function (a) { return sel[a.sku] && (isIntake(a) || a.kategorie === 'Ladeluftkühler' || a.kategorie === 'Turboladersysteme'); }).map(function (a) { return a.sku; });
  }
  function intakeSelected(sel) {
    var found = false;
    (S.cc.artikel || []).forEach(function (a) { if (sel[a.sku] && isIntake(a)) found = true; });
    return found;
  }
  function status(a, isStage) {
    var z = a.zulassung, cls = classOf(a.sku), sel = selectedSkus();
    if (isStage && S.stage === a.sku && z !== 'keine_zulassung') cls = 'legal';
    var nm = a.name || '';
    /* feste Regeln von Fiona */
    if (a._extra) return { k: 'ok', t: 'Legal – laut Homologationsliste (einzeln, ohne Stage)' };
    if (/Einspritzd/i.test(nm)) return { k: 'bad', t: 'Keine Strassenzulassung' };
    /* Ersatzteile (Name enthält "Ersatz" oder "Nur"): Legalität beim Hauptartikel */
    if (/Ersatz|\bNur\b/.test(nm)) return { k: 'info', t: 'Ersatzteil – Legalität siehe Hauptartikel' };
    if (isFilter(a) && !/Reinigungskit/i.test(nm)) {
      return intakeSelected(sel) ? { k: 'ok', t: 'Legal mit der gewählten Ansaugung' } : { k: 'warn', t: 'Nur legal in Kombination mit einer legalen APR Ansaugung' };
    }
    if (a.sku === 'CI100038M') {
      return sel['CI100038'] ? { k: 'ok', t: 'Legal mit der Ansaugung' } : { k: 'warn', t: 'Nur legal in Kombination mit der Ansaugung (Turbo Inlet System + Open Air Intake)' };
    }
    var noSilencerOnly = a.hinweis && /nur für die Variante mit Schalldämpfer/i.test(a.hinweis);
    var sh = shopFor(a);
    /* Abgasteile in der Ausführung "ohne Schalldämpfer" haben keine Zulassung (auch keine ECE) - unabhängig davon, ob der Hinweistext in den Daten steht */
    var vt = (sh && sh.sel.vt) || '';
    if ((noSilencerOnly && /ohne/i.test(vt)) || (a.kategorie === 'Abgasanlage' && /ohne\s+Schalld/i.test(vt))) return { k: 'bad', t: 'Ohne Schalldämpfer: keine Strassenzulassung' };
    var comb = noWot(a.kombination_mit || []);
    if (cls === 'verlust' || z === 'verlust_zulassung') return { k: 'bad', t: 'Verliert die Zulassung' + (S.stage ? ' mit ' + nameOf(S.stage) : '') };
    /* Abgasanlage mit ECE: einzeln legal. Kommt ein Motorenteil dazu, gilt die ECE nicht mehr, ausser ein DTC-Kombinationsgutachten deckt es ab:
       - mit Stage: massgebend ist stage_matrix[Stage] (Homologationsliste: ○/● in der Abgas-/Downpipe-Spalte der Stage-Zeile)
       - ohne Stage, nur Hardware (Ansaugung/LLK/Turbo): je Teil stage_matrix[<Teil-SKU>].legal (abgedeckt) bzw. .verlust (Verlust); ohne Eintrag gilt Verlust
       - kombination_mit am Abgasteil zählt weiterhin als Kombinationsgutachten */
    if (a.kategorie === 'Abgasanlage' && z === 'ece') {
      var mx = S.cc.stage_matrix || {};
      var combOk = comb.some(function (s) { return sel[s]; });
      var hwLost = motorHardware(sel).filter(function (h) { return mx[h] && (mx[h].verlust || []).indexOf(a.sku) >= 0; });
      if (hwLost.length) return { k: 'bad', t: 'Verliert die Zulassung mit ' + nameOf(hwLost[0]) };
      if (S.stage) {
        var stg = (S.cc.stages || []).filter(function (x) { return x.sku === S.stage; })[0];
        var me = mx[S.stage] || {};
        var stageCovers = !wotVag() && stg && stg.zulassung !== 'keine_zulassung' &&
          ((me.legal || []).indexOf(a.sku) >= 0 || (me.pflicht || []).some(function (p) { return p.split('|').indexOf(a.sku) >= 0; }));
        if (stageCovers || combOk) return { k: 'ok', t: 'Legal mit ' + nameOf(S.stage) + ' (DTC Gutachten für diese Kombination)' };
        return { k: 'bad', t: 'Nicht mehr legal mit ' + nameOf(S.stage) + ': ECE gilt nur ohne Leistungssteigerung – für diese Kombination liegt kein DTC Gutachten vor' };
      }
      var hw = motorHardware(sel);
      if (hw.length) {
        var open = hw.filter(function (h) { return !(mx[h] && (mx[h].legal || []).indexOf(a.sku) >= 0); });
        if (!open.length || combOk) return { k: 'ok', t: 'Legal mit DTC Gutachten (in dieser Kombination)' };
        return { k: 'bad', t: 'Nicht mehr legal mit ' + nameOf(open[0]) + ': ECE gilt nur ohne Ansaugung, Ladeluftkühler oder Turbolader – für diese Kombination liegt kein DTC Gutachten vor' };
      }
      return { k: 'ok', t: 'Legal – ECE-Zulassung' };
    }
    if (cls === 'legal') {
      if (z === 'keine_zulassung_noetig') return { k: 'ok', t: 'Immer legal – keine Zulassung erforderlich' };
      if (z === 'nur_in_kombination') return { k: 'ok', t: S.stage ? 'Legal mit ' + nameOf(S.stage) : 'Legal in dieser Kombination' };
      if (z === 'ece') return { k: 'ok', t: 'Legal – ECE-Zulassung' };
      if (z === 'teilegutachten') return { k: 'ok', t: 'Legal – mit DTC Gutachten' };
      return { k: 'ok', t: 'Legal' };
    }
    if (cls === 'kombi' || (!cls && z === 'nur_in_kombination')) {
      var met = comb.filter(function (s) { return sel[s]; });
      if (met.length) return { k: 'ok', t: 'Legal mit ' + nameOf(met[0]) };
      return { k: 'warn', t: 'Nur legal in Kombination mit: ' + (comb.length ? comb.map(nameOf).join(' oder ') : (a.kombination_nur_hinweis || 'siehe Hinweis')) };
    }
    if (cls === 'illegal' || z === 'keine_zulassung') return { k: 'bad', t: 'Keine Strassenzulassung' };
    if (z === 'keine_zulassung_noetig') return { k: 'ok', t: 'Immer legal – keine Zulassung erforderlich' };
    return { k: 'ok', t: 'Legal' };
  }

  /* ---------- Rendering ---------- */
  function badge(st) { return '<span class="apr-ov-badge apr-ov-badge--' + st.k + '">' + esc(st.t) + '</span>'; }
  function priceHtml(price, compare) {
    var h = '<span class="apr-ov-price">' + chf(price) + '</span>';
    if (compare && compare > price) h += ' <s class="apr-ov-old">' + chf(compare) + '</s>';
    return h;
  }
  function stockHtml(orderable, sh) {
    if (!orderable) return '<span class="apr-ov-lead apr-ov-lead--na">' + (sh.c.s === 'ACTIVE' ? 'Nicht lieferbar' : 'Noch nicht bestellbar') + '</span>';
    return '<span class="apr-ov-lead">' + (sh.lead ? 'Lieferzeit: ' + esc(sh.lead) : '') + '</span>';
  }
  function memberLabel(m) { var s = shopFor(m); var vt = s && s.sel.vt; return (vt || m.name || m.sku) + ' – ' + chf(s ? s.price : 0); }
  function groupSelect(row) {
    if (row.isSet || row.members.length < 2) return '';
    var cur = selMember(row).sku;
    return '<select class="apr-ov-vsel" data-gsel="' + esc(row.key) + '" aria-label="Ausführung">' + row.members.map(function (m) {
      return '<option value="' + esc(m.sku) + '"' + (m.sku === cur ? ' selected' : '') + '>' + esc(memberLabel(m)) + '</option>';
    }).join('') + '</select>';
  }
  function variantSelect(a, sh) {
    if (!sh.variants) return '';
    return '<select class="apr-ov-vsel" data-vsel="' + esc(a.sku) + '" aria-label="Ausführung">' + sh.variants.map(function (v) {
      return '<option value="' + esc(v.sku) + '"' + (v.c === sh.sel ? ' selected' : '') + '>' + esc(v.c.vt) + ' – ' + chf(S.live[v.c.v] ? S.live[v.c.v].price : v.c.p) + '</option>';
    }).join('') + '</select>';
  }
  function thumb(sh) {
    var lv = sh && S.live[sh.sel.v], u = lv && lv.img;
    if (!u) return '<div class="apr-ov-thumb" aria-hidden="true"></div>';
    return '<div class="apr-ov-thumb"><img src="' + esc(u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=140') + '" alt="" loading="lazy" width="64" height="64"></div>';
  }
  function cleanHint(h) { return esc(String(h).replace(/\b[A-Z]{1,3}-\d{3,5}\/\d{2}\b/g, '').replace(/Motorsteuergerät-Freischaltung nicht enthalten/g, 'Motorsteuergerät-Freischaltung bereits im Preis enthalten.')).replace(/\n/g, '<br>'); }
  function rowHtml(row) {
    var a = selMember(row), st = status(a, false), sh = shopFor(a);
    if (!sh) return '';
    var key = row.key, checked = !!S.ticked[key];
    var price = sh.price, compare = sh.compare, orderable = sh.orderable, name = a.name, skuTxt = sh.sku, extra = '';
    if (row.isSet) {
      var b = row.set[0], sb = shopFor(b);
      name = a.name + ' + ' + b.name + ' (Set)';
      if (sb) { price = sh.price + sb.price; compare = (sh.compare || sh.price) + (sb.compare || sb.price); if (compare <= price) compare = null; orderable = sh.orderable && sb.orderable; skuTxt = sh.sku + ' + ' + sb.sku; }
      else { orderable = false; }
    }
    if (a.leistung_ps || a.drehmoment_nm) extra += '<span class="apr-ov-gain">+' + (a.leistung_ps || 0) + ' PS / +' + (a.drehmoment_nm || 0) + ' Nm</span>';
    var hint = a.hinweis ? '<div class="apr-ov-hint">' + cleanHint(a.hinweis) + '</div>' : '';
    var apfl = artikelPflicht(a);
    var apflHint = apfl.length ? '<div class="apr-ov-hint">Für den Verbau zusätzlich nötig: ' + apfl.map(function (p) { return p.split('|').map(nameOf).join(' oder '); }).join(' · ') + '</div>' : '';
    return '<li class="apr-ov-item apr-ov-item--' + st.k + (checked ? ' is-checked' : '') + '" data-sku="' + esc(key) + '">' +
      '<label class="apr-ov-check"><input type="checkbox" name="apr-part-' + esc(key) + '" data-pick="' + esc(key) + '"' + (checked ? ' checked' : '') + (orderable ? '' : ' disabled') + '><span class="apr-ov-check-box" aria-hidden="true"></span></label>' + thumb(sh) +
      '<div class="apr-ov-main"><div class="apr-ov-name">' + esc(name) + '</div>' +
      '<div class="apr-ov-meta"><span class="apr-ov-brandtag">' + esc(a.hersteller || 'APR') + '</span><span class="apr-ov-sku">' + esc(skuTxt) + '</span>' + extra + '</div>' +
      '<div class="apr-ov-statusrow">' + badge(st) + '</div>' + hint + apflHint + groupSelect(row) + variantSelect(a, sh) + '</div>' +
      '<div class="apr-ov-buy"><div>' + priceHtml(price, compare) + '</div>' + stockHtml(orderable, sh) +
      '<button type="button" class="apr-ov-add" data-add="' + esc(key) + '"' + (orderable ? '' : ' disabled') + '>In den Warenkorb</button></div></li>';
  }
  function stageItemHtml(a) {
    var st = status(a, true), sh = shopFor(a);
    if (!sh) return '';
    var checked = S.stage === a.sku, extra = '';
    var m = ((S.cc.stage_matrix || {})[a.sku]) || {};
    var perf = '';
    if (a.ps) perf = '<div class="apr-ov-perf">' + a.ps + ' PS' + (a.nm ? ' / ' + a.nm + ' Nm' : '') + (a.ps_plus ? ' <em>(+' + a.ps_plus + ' PS' + (a.nm_plus ? ' / +' + a.nm_plus + ' Nm' : '') + ')</em>' : '') + (a.vmax ? ' · Vmax ' + a.vmax + ' km/h' : '') + (a.db_stand ? ' · ' + esc(a.db_stand) + ' dB' : '') + '</div>';
    var pfl = pflichtOf(a.sku);
    var pflicht = pfl.length ? '<div class="apr-ov-hint">Für die Zulassung zusätzlich nötig: ' + pfl.map(function (p) { return p.split('|').map(nameOf).join(' oder '); }).join(' · ') + '</div>' : '';
    var hint = a.hinweis ? '<div class="apr-ov-hint">' + cleanHint(a.hinweis) + '</div>' : '';
    return '<li class="apr-ov-item apr-ov-item--' + st.k + (checked ? ' is-checked' : '') + '" data-sku="' + esc(a.sku) + '">' +
      '<label class="apr-ov-check"><input type="radio" name="apr-stage" data-pick="' + esc(a.sku) + '" data-stage="1"' + (checked ? ' checked' : '') + (sh.orderable ? '' : ' disabled') + '><span class="apr-ov-check-box" aria-hidden="true"></span></label>' + thumb(sh) +
      '<div class="apr-ov-main"><div class="apr-ov-name">' + esc(a.name) + '</div>' +
      '<div class="apr-ov-meta"><span class="apr-ov-brandtag">' + esc(a.hersteller || 'APR') + '</span><span class="apr-ov-sku">' + esc(sh.sku) + '</span>' + extra + '</div>' +
      perf + pflicht + '<div class="apr-ov-statusrow">' + badge(st) + '</div>' + hint + '</div>' +
      '<div class="apr-ov-buy"><div>' + priceHtml(sh.price, sh.compare) + '</div>' + stockHtml(sh.orderable, sh) +
      '<button type="button" class="apr-ov-add" data-add="' + esc(a.sku) + '" data-isstage="1"' + (sh.orderable ? '' : ' disabled') + '>In den Warenkorb</button></div></li>';
  }
  function stageBlock() {
    var all = (S.cc.stages || []).filter(function (a) { return shopFor(a); });
    if (!all.length) return '';
    var shown = S.onlyLegal ? all.filter(function (a) { return status(a, true).k === 'ok'; }) : all;
    var h = '<section class="apr-ov-sec"><h3 class="apr-ov-h2">Leistungssteigerung</h3><ul class="apr-ov-list">';
    h += '<li class="apr-ov-item apr-ov-item--none' + (!S.stage ? ' is-checked' : '') + '"><label class="apr-ov-check"><input type="radio" name="apr-stage" data-nostage="1"' + (!S.stage ? ' checked' : '') + '><span class="apr-ov-check-box" aria-hidden="true"></span></label><div class="apr-ov-thumb" aria-hidden="true"></div><div class="apr-ov-main"><div class="apr-ov-name">Ohne Leistungssteigerung (Serienstand)</div><div class="apr-ov-meta"><span>' + esc(S.cc.fahrzeug.ps) + ' PS / ' + esc(S.cc.fahrzeug.nm) + ' Nm</span></div></div></li>';
    shown.forEach(function (a) { h += stageItemHtml(a); });
    return h + '</ul></section>';
  }
  /* Sortierung innerhalb einer Kategorie: zulassungspflichtige Teile oben, immer-legale Teile (z.B. Zündkerzen) mittig, Ersatzteile unten */
  function rowSortRank(row) {
    var a = selMember(row), nm = a.name || '';
    if (/Ersatz|\bNur\b/.test(nm)) return 2;
    if (a.zulassung === 'keine_zulassung_noetig') return 1;
    return 0;
  }
  function catList() {
    var groups = {};
    rowsList().forEach(function (row) {
      var a = selMember(row);
      if (!shopFor(a)) return;
      if (classOf(a.sku) === 'versteckt') return;
      if (S.onlyLegal && status(a).k !== 'ok') return;
      var c = catOf(a);
      (groups[c] = groups[c] || []).push(row);
    });
    var cats = Object.keys(groups).sort(function (x, y) { var i = CAT_ORDER.indexOf(x), j = CAT_ORDER.indexOf(y); return (i < 0 ? 99 : i) - (j < 0 ? 99 : j) || x.localeCompare(y); });
    return cats.map(function (c) { var items = groups[c].slice().sort(function (x, y) { return rowSortRank(x) - rowSortRank(y); }); return '<section class="apr-ov-sec"><h3 class="apr-ov-h2">' + esc(c) + '</h3><ul class="apr-ov-list">' + items.map(rowHtml).join('') + '</ul></section>'; }).join('');
  }
  /* Rendert "A oder B" für eine Pflicht-Alternative, mit einem Auswahlkästchen pro auffindbarer SKU, damit man sie direkt hier ankreuzen kann statt sie oben suchen zu müssen */
  function pflichtAltsHtml(alts) {
    return alts.map(function (s) {
      var found = findRowBySku(s), label = nameOf(s);
      if (!found) return esc(label);
      var curSku = selMember(found.row).sku;
      var checked = !!S.ticked[found.row.key] && curSku === s;
      return '<label class="apr-ov-fixpick"><input type="checkbox" data-fixpick="' + esc(s) + '" data-fixrow="' + esc(found.row.key) + '"' + (checked ? ' checked' : '') + '> ' + esc(label) + '</label>';
    }).join(' oder ');
  }
  function verdict() {
    var sel = selectedSkus(), probs = [];
    rowsList().forEach(function (r) {
      if (!S.ticked[r.key]) return;
      var a = selMember(r), st = status(a, false);
      if (st.k !== 'ok' && st.k !== 'info') probs.push(esc(a.name + ': ' + st.t));
      artikelPflicht(a).forEach(function (p) { var alts = p.split('|'); if (!alts.some(function (s) { return sel[s]; })) probs.push('Für ' + esc(a.name) + ' zusätzlich nötig: ' + pflichtAltsHtml(alts)); });
    });
    if (S.stage) {
      var sa = (S.cc.stages || []).filter(function (x) { return x.sku === S.stage; })[0];
      if (sa) { var st2 = status(sa, true); if (st2.k !== 'ok') probs.push(esc(sa.name + ': ' + st2.t)); }
      (wotVag() ? [] : pflichtOf(S.stage)).forEach(function (p) { var alts = p.split('|'); if (!alts.some(function (s) { return sel[s]; })) probs.push('Für ' + esc(nameOf(S.stage)) + ' zusätzlich nötig: ' + pflichtAltsHtml(alts)); });
    }
    return probs;
  }
  function cartItems() {
    var items = [];
    rowsList().forEach(function (r) {
      if (!S.ticked[r.key]) return;
      var a = selMember(r), sh = shopFor(a); if (!sh || !sh.orderable) return;
      items.push({ id: sh.sel.v, quantity: 1, price: sh.price });
      if (r.isSet) { var sb = shopFor(r.set[0]); if (sb && sb.orderable) items.push({ id: sb.sel.v, quantity: 1, price: sb.price }); }
    });
    if (S.stage) { var sa = (S.cc.stages || []).filter(function (x) { return x.sku === S.stage; })[0]; var ss = sa && shopFor(sa); if (ss && ss.orderable) items.push({ id: ss.sel.v, quantity: 1, price: ss.price }); }
    return items;
  }
  function renderBar() {
    var items = cartItems();
    if (!items.length && !S.stage) { els.bar.hidden = true; return; }
    var total = 0; items.forEach(function (i) { total += i.price; });
    var pr = verdict();
    var vd = pr.length ? '<div class="apr-ov-verdict apr-ov-verdict--bad"><strong>Diese Auswahl ist so nicht strassenzugelassen.</strong><ul>' + pr.map(function (p) { return '<li>' + p + '</li>'; }).join('') + '</ul></div>' : '<div class="apr-ov-verdict apr-ov-verdict--ok"><strong>Diese Auswahl ist legal zulassungsfähig.</strong></div>';
    els.bar.hidden = false;
    els.bar.innerHTML = vd + '<div class="apr-ov-bar-row"><span>' + items.length + ' Artikel · <strong>' + chf(total) + '</strong></span><button type="button" class="apr-ov-cta" data-addall>Auswahl in den Warenkorb</button></div>';
  }
  function render() {
    if (!S.cc) { els.body.innerHTML = '<p class="apr-fit-note">Bitte wähle oben dein Fahrzeug genauer aus – dann siehst du, was dafür erhältlich ist.</p>'; els.bar.hidden = true; return; }
    els.body.innerHTML = '<label class="apr-ov-toggle"><input type="checkbox" data-onlylegal' + (S.onlyLegal ? ' checked' : '') + '> Nur legale Teile anzeigen</label>' +
      '<p class="apr-fit-note">Zulassungsangaben nach APR-Konfigurator Schweiz, Stand ' + esc(S.cc.stand || '') + '. Massgebend ist die Typengenehmigung deines Fahrzeugs.</p>' + stageBlock() + catList();
    renderBar();
  }

  /* ---------- Warenkorb ---------- */
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: i.quantity }; }) }) }).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.status && j.status >= 400) throw new Error(j.description || 'Fehler');
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      return j;
    });
  }
  function itemsForKey(key, isStage) {
    if (isStage) { var sa = (S.cc.stages || []).filter(function (x) { return x.sku === key; })[0]; var ss = sa && shopFor(sa); return ss && ss.orderable ? [{ id: ss.sel.v, quantity: 1 }] : []; }
    var row = rowsList().filter(function (r) { return r.key === key; })[0]; if (!row) return [];
    var a = selMember(row), sh = shopFor(a), out = [];
    if (sh && sh.orderable) out.push({ id: sh.sel.v, quantity: 1 });
    if (row.isSet) { var sb = shopFor(row.set[0]); if (sb && sb.orderable) out.push({ id: sb.sel.v, quantity: 1 }); }
    return out;
  }
  function flash(btn, txt) { var o = btn.textContent; btn.textContent = txt; btn.disabled = true; setTimeout(function () { btn.textContent = o; btn.disabled = false; }, 1600); }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-onlylegal]')) { S.onlyLegal = t.checked; render(); return; }
    if (t.matches('[data-nostage]')) { S.stage = null; render(); return; }
    if (t.matches('[data-pick]')) { var k = t.getAttribute('data-pick'); if (t.hasAttribute('data-stage')) S.stage = k; else S.ticked[k] = t.checked; render(); return; }
    if (t.matches('[data-vsel]')) { S.variantSel[t.getAttribute('data-vsel')] = t.value; render(); return; }
    if (t.matches('[data-gsel]')) { S.variantSel['g:' + t.getAttribute('data-gsel')] = t.value; render(); return; }
    if (t.matches('[data-fixpick]')) {
      var fsku = t.getAttribute('data-fixpick'), frow = t.getAttribute('data-fixrow');
      if (t.checked) { S.variantSel['g:' + frow] = fsku; S.ticked[frow] = true; } else { S.ticked[frow] = false; }
      render();
    }
  });
  root.addEventListener('click', function (e) {
    var kc = e.target.closest('[data-key]');
    if (kc) { var key = S.pendingKeys[parseInt(kc.getAttribute('data-key'), 10)]; remember(S.pendingCol, key); loadCandidates(S.links.k[key], whoOf(key)); return; }
    var chip = e.target.closest('[data-chip]');
    if (chip) { choose(parseInt(chip.getAttribute('data-chip'), 10)); return; }
    var b = e.target.closest('[data-add]');
    if (b) { var items = itemsForKey(b.getAttribute('data-add'), b.hasAttribute('data-isstage')); if (!items.length) return; addItems(items).then(function () { flash(b, 'Hinzugefügt'); }).catch(function () { flash(b, 'Fehler'); }); return; }
    var all = e.target.closest('[data-addall]');
    if (all) { var list = cartItems(); if (!list.length) return; addItems(list).then(function () { flash(all, 'Hinzugefügt'); }).catch(function () { flash(all, 'Fehler'); }); }
  });

  var lastFocus = null;
  function openModal() { lastFocus = document.activeElement; els.modal.hidden = false; document.documentElement.style.overflow = 'hidden'; els.close.focus(); }
  function closeModal() { els.modal.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  els.open.addEventListener('click', openModal);
  els.close.addEventListener('click', closeModal);
  els.modal.addEventListener('click', function (e) { if (e.target === els.modal) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !els.modal.hidden) closeModal(); });

  var st = document.createElement('style');
  st.textContent = '.apr-ov-badge--info{background:#E9ECF1;color:#3B4252}.apr-fit .apr-ov-item{grid-template-columns:28px 64px 1fr auto}.apr-ov-thumb{width:64px;height:64px;border-radius:8px;background:#F3F1EC;display:flex;align-items:center;justify-content:center;overflow:hidden}.apr-ov-thumb img{width:100%;height:100%;object-fit:contain;display:block}@media(max-width:760px){.apr-fit .apr-ov-item{grid-template-columns:28px 64px 1fr}}.apr-ov-fixpick{display:inline-flex;align-items:center;gap:4px;cursor:pointer;text-decoration:underline;text-underline-offset:2px}.apr-ov-fixpick input{margin:0}';
  document.head.appendChild(st);

  start();
})();
